export const labels = {
  rowValuePath: "Query from table row",
  columnValuePath: "Query from table column",
  columnGroupBy: "Group by column values",
  rowGroupBy: "Group by row values",
  aggCondition: "Condition",
  queryWithReplacedParams: "Query from search",
  searchFilterQuery: "Query from search filters",
  streams: "Streams",
  searchWithinMs: "Search within ms",
  lutParameters: "Lookup-table parameters",
  searchFromValue: "Query from value"
};
export const aggregationGroup = ["columnGroupBy", "rowGroupBy", "aggCondition"];
export const searchGroup = [
  "rowValuePath",
  "columnValuePath",
  "queryWithReplacedParams",
  "searchFilterQuery",
  "searchFromValue"
];
export const strategiesLabels = {
  EXACT: {
    label: "Exactly this value",
    description: "Strategy includes all search queries, filters, etc which relate to current search view"
  },
  ROW: { label: "Any in row", description: "Strategy includes row pivots" },
  COL: { label: "Any in column", description: "Strategy includes column pivots" },
  ALL: {
    label: "Any in widget",
    description: "Strategy includes all row and column pivot values, related to selected value"
  },
  CUSTOM: { label: "Custom", description: "You can select any search part" }
};
